import React from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';

const SidebarButton = ({ iconType, text, style }) => {
  return(
    <>
      <SidebarIcon
        fixedWidth="50px"
        type={iconType}
        style={style}
      />
      <span>{text}</span>
      
    </>
  )
}

const SidebarIcon = styled(Icon)`
  margin-right: 20px;
  margin-left: -17px;
  text-align: center;
`

export default React.memo(SidebarButton);